import { API } from 'aws-amplify';

export interface ActivityLogPayload {
    contentId: string;
    contentType: 'image' | 'video' | 'document' | 'audio' | 'article' | 'podcast' | 'playlist' | 'season';
    duration: number;
	deviceType: string;
	actionName: string;
}

export const logContentActivity = async (payload: ActivityLogPayload): Promise<any> =>
{
	try
	{
		const response = await API.post(
			'userManagement',
			'/api/v1/activity-logs',
			{
				queryStringParameters : {
					type : 'resource'
				},
				body : payload
			}
		);

		return response;
	}
	catch (error)
	{
		console.error('Error logging content activity:', error);
		throw error;
	}
};
